<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.remark') }}</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <input-field :readonly="!editable" v-model="form.codigo" id="codigo" placeholder="##">
                                <span>{{ $t('message.codigo') }}</span>
                                <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.codigo[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <input-field v-model="form.descripcion" id="descripcion">
                                <span>{{ $t('message.descripcion') }}</span>
                                <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.descripcion[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-save"></i><span>{{ $t('message.guardar') }}</span></button>
            <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>{{ $t('message.cancelar') }}</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Object,
            required : false, 
            default : function () {
                return {
                    id : '',
                    codigo : '',
                    descripcion : '',
                    estado : 'N'
                };
            }
        }
    },
    computed : {
        editable : function () {
            return this.form.estado === 'N';
        }
    },
    data : function () {
        return {
            form : this.value,
            errores : {},
            url : url
        }
    },
    methods : {
        aceptar : function () {
            let urlRequest = this.url + '/remarks';
            if (this.form.estado !== 'N')
            {
                urlRequest += '/' + this.form.id;
                this.form._method = 'PUT';
            }
            else 
                this.form._method = undefined;
            let that = this;
            axios.post(urlRequest, this.form).then(function (response) {
                swal(that.$t('message.saved'), that.$t('message.aviso'), 'success');
                that.$emit('saved', response.data);
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal(that.$t('message.errorValidacion'), that.$t('message.aviso'), 'warning');
                        }
                        else 
                            swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                    }
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/remarks/Remark.vue